// polyfil for IE11 - must be first
import "core-js/stable";
import React from "react";
import ReactDOM from "react-dom";
import TagManager from "react-gtm-module";

import App from "./components/App";

const tagManagerArgs = {
    gtmId: `${window.gtmContainerID}`
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(<App />, document.getElementById("app-my-deliveries"));
